import CHECKBOX_TRUE_VALUE from "../../constants/form/CHECKBOX_TRUE_VALUE";

export default function toBoolean(value: unknown): boolean {
  return value === CHECKBOX_TRUE_VALUE;
}
